<template>
  <div>
    <template v-if="!userDialogVisible">
      <el-row :gutter="20">
        <el-col :span="6">
          <div>
            <el-input
              v-model="key_unit"
              placeholder="请输入关键字或词"
              class="input-with-select"
              size="small"
              suffix-icon="el-icon-search"
            />
          </div>
        </el-col>
        <el-col :span="18" class="btn">
          <div>
            <el-button
              type="primary"
              icon="el-icon-folder-add"
              size="small"
              @click="down"
              >批量导出
            </el-button>
            <el-button
              v-permission="['用户管理导入用户']"
              type="primary"
              icon="el-icon-download"
              size="small"
              v-if="proStatus !== '项目已锁定'"
              @click="userImpor"
              >批量新增用户
            </el-button>
            <el-button
              v-permission="['用户管理新增用户']"
              type="primary"
              icon="el-icon-circle-plus-outline"
              size="small"
              v-if="proStatus !== '项目已锁定'"
              @click="createUser"
              >新增用户
            </el-button>
          </div>
        </el-col>
      </el-row>
      <div class="container-table">
        <el-table
          ref="filterTable"
          v-loading="loading"
          stripe
          size="mini"
          :data="infoData"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          @filter-change="filterChange"
          border
          :cell-style="cellStyle"
        >
          <!-- <el-table-column type="selection" width="50" /> -->
          <el-table-column prop="the_num" label="用户编号" width="100" />
          <el-table-column prop="name" label="姓名" width="160">
            <template slot-scope="scope">
              <div style="font-size: 12px">{{ scope.row.name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="邮箱" width="250" />
          <el-table-column prop="phone" label="手机号" width="120" />
          <el-table-column prop="unit_name_list" label="关联单位" width="350" />
          <el-table-column prop="role_name" label="角色" />
          <el-table-column prop="is_enable" label="状态" width="100" sortable>
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.is_enable"
                type="text"
                size="mini"
                style="font-size: 12px; color: #52c41a"
                >已启用
              </el-button>
              <el-button
                v-if="!scope.row.is_enable"
                type="text"
                size="mini"
                style="font-size: 12px; color: #bfbfbf"
                >已禁用
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-link
                v-permission="['用户管理编辑用户']"
                type="primary"
                :underline="false"
                class="edit"
                :disabled="proStatus === '项目已锁定'"
                @click="detail(scope.row)"
                >编辑
              </el-link>
              <el-link
                v-permission="['用户管理删除用户']"
                :disabled="proStatus === '项目已锁定'"
                type="primary"
                :underline="false"
                class="edit"
                style="font-size: 12px"
                @click="del(scope.row)"
                >删除
              </el-link>
              <el-link
                v-if="scope.row.is_enable"
                v-permission="['用户管理禁用用户']"
                type="primary"
                :underline="false"
                style="font-size: 12px"
                @click="disableClick(scope.row)"
                >禁用
              </el-link>
              <el-link
                v-if="!scope.row.is_enable"
                v-permission="['用户管理禁用用户']"
                type="primary"
                :underline="false"
                style="font-size: 12px"
                @click="enableClick(scope.row)"
                >启用
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pages">
        <el-pagination
          samll
          background
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </template>

    <div class="roleadd" v-else>
      <el-form
        ref="formRef"
        :model="ruleForm"
        label-position="left"
        label-width="90px"
      >
        <div class="form_box">
          <div class="title_row">
            <span><svg-icon icon-class="must" /> 姓名：</span>
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入用户姓名"
              size="small"
            />
          </div>
          <div class="title_row">
            <span><svg-icon icon-class="must" /> 邮箱：</span>
            <el-input
              v-model="ruleForm.email"
              placeholder="请输入用户邮箱"
              size="small"
            />
          </div>
          <div class="title_row">
            <span><svg-icon icon-class="must" /> 手机号：</span>
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入用户手机号"
              size="small"
            />
          </div>

          <div class="title_row">
            <span><svg-icon icon-class="must" /> 关联单位：</span>
            <el-select
              size="small"
              v-model="ruleForm.unit_id_list"
              placeholder="请选择用户关联单位"
              :multiple="true"
              filterable
              collapse-tags
            >
              <el-checkbox
                v-model="isAllUnit"
                style="margin-left: 10px"
                @change="allUnit"
                >全选
              </el-checkbox>
              <template v-for="(item, index) in unitList">
                <el-option
                  :key="index"
                  :value="item.id"
                  :label="`[ ${item.code} ] ${item.name}`"
                >
                </el-option>
              </template>
            </el-select>
          </div>

          <div class="title_row">
            <span><svg-icon icon-class="must" /> 角色：</span>
            <el-select
              v-model="ruleForm.role_id"
              placeholder="请选择用户角色"
              @change="changeRole"
              size="small"
            >
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="form_box">
          <div class="title_row">
            <span><svg-icon icon-class="must" />项目权限：</span>
          </div>
          <el-checkbox-group v-model="ruleForm['authority']['项目管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />项目管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="编辑项目">编辑项目</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="锁定项目">锁定/解锁项目</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="启动项目">启动项目</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="发布到PROD">发布到PROD</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>
          <el-checkbox-group v-model="ruleForm['authority']['项目首页']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />项目首页</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="4" class="el-row_first">
                    <el-checkbox label="可视化界面">可视化界面</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>
          <el-checkbox-group v-model="ruleForm['authority']['单位管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />单位管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="导入单位">导入单位</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="新增单位">新增单位 </el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="编辑单位">编辑单位</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="删除单位">删除单位</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="禁用单位">禁用单位</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>
          <el-checkbox-group v-model="ruleForm['authority']['角色管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />角色管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="新增角色">新增角色</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="导入角色">导入角色</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="编辑角色">编辑角色</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="删除角色">删除角色</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['访视管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />访视管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="新增访视">新增访视</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="编辑访视">编辑访视</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="删除访视">删除访视</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['用户管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />用户管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="导入用户">导入用户</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="新增用户">新增用户</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="编辑用户">编辑用户</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="删除用户">删除用户</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="禁用用户">禁用用户</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['通知管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />通知管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="导入">导入</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="编辑">编辑</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="删除">删除</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['随机管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />随机管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="编辑随机化">编辑随机化</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['盲底管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />盲底管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="上传盲底">上传盲底</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="生成盲底">生成盲底</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="测试盲底">测试盲底</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="增加盲底">增加盲底</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['受试者管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />受试者管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="登记受试者">登记受试者</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="切换访视">切换访视</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="查看">查看</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="结果导出">结果导出</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="查看受试者组别(双盲)"
                      >查看受试者组别(双盲)</el-checkbox
                    >
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['受试者脱落']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />受试者脱落</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="3" class="el-row_first">
                    <el-checkbox label="脱落">脱落</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="查看">查看</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="结果导出">结果导出</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <template v-if="blind === '双盲'">
            <el-checkbox-group v-model="ruleForm['authority']['紧急揭盲']">
              <el-row>
                <el-col :span="2" class="el-row_title"><i />紧急揭盲</el-col>
                <el-col :span="21">
                  <el-row>
                    <el-col :span="3" class="el-row_first">
                      <el-checkbox label="紧急揭盲">紧急揭盲</el-checkbox>
                    </el-col>
                    <el-col :span="3">
                      <el-checkbox label="查看">查看</el-checkbox>
                    </el-col>
                    <el-col :span="3">
                      <el-checkbox label="结果导出">结果导出</el-checkbox>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </template>

          <el-checkbox-group v-model="ruleForm['authority']['揭盲管理']">
            <el-row>
              <el-col :span="2" class="el-row_title"><i />揭盲管理</el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="4" class="el-row_first">
                    <el-checkbox label="一级/二级揭盲"
                      >一级/二级揭盲</el-checkbox
                    >
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="查看">查看</el-checkbox>
                  </el-col>
                  <el-col :span="3">
                    <el-checkbox label="下载">下载</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>

          <el-checkbox-group v-model="ruleForm['authority']['操作轨迹']">
            <el-row>
              <el-col :span="2" class="el-row_title"> <i />操作轨迹 </el-col>
              <el-col :span="21">
                <el-row>
                  <el-col :span="4" class="el-row_first">
                    <el-checkbox label="下载">下载</el-checkbox>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </div>
        <div class="footBtns">
          <el-button
            type="primary"
            style="display: flex; justify-content: center; align-items: center"
            @click="submitForm"
            :loading="is_loading"
            >保存</el-button
          >
          <el-button @click="fail">取消</el-button>
        </div>
      </el-form>
    </div>

    <!--创建用户-->
    <!-- <el-dialog
      :visible.sync="userDialogVisible"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="cancel"
    >
      <div slot="title" class="title">{{ userId ? "编辑" : "新增" }}用户</div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="proInfo"
        label-width="100px"
      >
        <el-form-item label="姓名：" prop="name" size="mini">
          <el-input v-model="ruleForm.name" placeholder="请输入角色名称"/>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email" size="mini">
          <el-input v-model="ruleForm.email" placeholder="请输入角色编号"/>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone" size="mini">
          <el-input v-model="ruleForm.phone" placeholder="请输入角色编号"/>
        </el-form-item>
        <el-form-item label="关联单位：" prop="unit_id_list" size="mini">
          <el-select
            v-model="ruleForm.unit_id_list"
            multiple
            collapse-tags
            placeholder="请选择关联单位"
            style="width: 100%"
          >
            <el-option
              v-for="(item, i) in unitList"
              :key="i"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="用户角色：" prop="role_id" size="mini">
          <el-select
            v-model="ruleForm.role_id"
            placeholder="请选择角色权限"
            style="width: 100%"
            @change="handleRole"
          >
            <el-option
              v-for="(item, i) in roleList"
              :key="i"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="clearForm"
          label="权限编辑："
          prop="role_id"
          size="mini"
        >
          <el-cascader
            v-model="ruleForm.authority"
            size="mini"
            :options="authorityData"
            :props="props"
            collapse-tags
            clearable
            style="width: 100%"
            @change="handleData"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary"
          @click="submitForm('ruleForm')"
        >保 存</el-button>
        <el-button size="mini" @click="cancel">取 消</el-button>
      </span>
    </el-dialog> -->
    <!--批量导入-->
    <el-dialog
      :visible.sync="downDialogVisible"
      width="40%"
      center
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">批量导出</div>
      <div class="proInfo">
        <el-row
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 6px;
          "
        >
          <el-col :span="3" style="">导出到：</el-col>
          <el-col :span="10" style="">
            <el-select v-model="to" placeholder="请选择下载" size="mini">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          @click="handleExportUser"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancelExport">取 消</el-button>
      </span>
    </el-dialog>
    <!--导入用户-->
    <div v-if="groupDialogVisible">
      <el-dialog
        :visible.sync="groupDialogVisible"
        width="40%"
        :close-on-click-modal="false"
        @close="groupDialogVisible = false"
        center
        class="export"
      >
        <div slot="title" class="title">{{ groupdialogTitle }}</div>
        <div v-if="uploadBol">
          <div align="center" id="updateStyle">
            <el-upload
              style="width: 100%"
              ref="upload"
              class="upload-demo"
              drag
              action="#"
              :on-change="changeFile"
              :auto-upload="false"
              accept=".xlsx,.xls"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击选择</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </div>
          <div class="footBtns" style="margin-bottom: 30px">
            <div class="ok" style="margin-left: 20px" @click="downloadTem">
              下载模版
            </div>
            <div class="ok" style="margin-left: 20px" @click="downloadSubmit">
              确认
            </div>
            <div
              class="cancel"
              style="margin-left: 20px"
              @click="groupDialogVisible = false"
            >
              取消
            </div>
          </div>
        </div>
        <div v-else>
          <div class="uploadText">
            文件内共有{{ uploadText.total }}条用户信息，{{
              uploadText.success
            }}条用户信息上传成功，{{ uploadText.fail }}条用户信息上传失败，{{
              uploadText.exist
            }}条用户信息已存在未上传。
          </div>
          <div class="footBtns" style="margin-bottom: 30px">
            <div
              class="ok"
              style="margin-left: 20px"
              @click="downloadFail"
              v-if="uploadText.fail"
            >
              下载失败信息
            </div>
            <div class="ok" style="margin-left: 20px" @click="downloadSuccess">
              确认
            </div>
            <div
              class="cancel"
              style="margin-left: 20px"
              @click="uploadBol = true"
            >
              取消
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getUserListApi,
  getUnitNo,
  getRoleNo,
  addUser,
  detailUser,
  editUser,
  del,
  userImport,
  allUser,
  exportUser,
  enable,
} from "@/api/proUser";
import { batch_add_check, batch_add } from "@/api/user";
import { getProjectId, getProStatus, getBlind } from "@/utils/auth";
import consumer from "./component/consumer";
import { roleList, detailRole } from "@/api/roleModel";

export default {
  name: "User",
  components: {
    consumer,
  },
  data() {
    const __checkAppraisalCategoryid = (rule, value, callback) => {
      if (!this.isFirstLoad) {
        if (value.length === 0) {
          callback(new Error("请选择角色权限"));
        } else {
          callback();
        }
      } else {
        this.isFirstLoad = false;
      }
    };
    return {
      cellStyle: {
        textAlign: "center",
      },
      groupdialogTitle: "用户批量上传",
      isAllUnit: false,
      clearForm: true,
      currentPage: 1,
      timer: "",
      pageSize: 10,
      total: null,
      infoData: [],
      key_unit: "",
      proId: "",
      files: new FormData(),
      uploadBol: true,
      uploadText: null,
      userDialogVisible: false,
      downDialogVisible: false,
      isFirstLoad: true,
      ruleForm: {
        name: "",
        email: "",
        phone: "",
        role_id: "",
        unit_id_list: "",
        //后端接口需要此格式
        authority: {
          项目管理: [],
          项目首页: [],
          单位管理: [],
          角色管理: [],
          访视管理: [],
          用户管理: [],
          通知管理: [],
          随机管理: [],
          盲底管理: [],
          受试者管理: [],
          受试者脱落: [],
          紧急揭盲: [],
          揭盲管理: [],
          操作轨迹: [],
        },
      },
      authorityData: [], // 权限数据
      statusList: [
        { text: "启用", value: true },
        { text: "禁用", value: false },
      ],
      options: [
        {
          value: "本地",
          label: "本地",
        },
        {
          value: "邮箱",
          label: "邮箱",
        },
        {
          value: "本地及邮箱",
          label: "本地及邮箱",
        },
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        role_id: [
          { required: true, message: "请选择用户角色", trigger: "change" },
        ],
        unit_id_list: [
          {
            required: true,
            validator: __checkAppraisalCategoryid,
            message: "请选择关联单位",
            trigger: "change",
          },
        ],
      },
      mode: "本地",
      unitList: [],
      roleList: [],
      userId: "",
      multipleSelection: [],
      userDiaVisiable: false,
      leftData: [],
      allUser: [],
      res_environment: window.sessionStorage.getItem("iwrs_environment"),
      loading: false,
      is_loading: false,
      to: "",
      // is_enable: false,
      props: {
        multiple: true,
        label: "label",
        value: "value",
        children: "children",
      },
      reqObj: {},
      enable: null,
      groupDialogVisible: false,
      proStatus: "", // 项目状态,
      blind: "",
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },
  created() {
    this.proId = getProjectId();
    this.blind = getBlind();
    this.getUserList();
    this.getUnitNo();
    this.getRoleNo();
    this.getAllUser();
    this.getRoleList(); // 获取权限
    this.proStatus = getProStatus();
  },
  methods: {
    changeFile(file, fileList) {
      this.files = file;
    },
    downloadFail() {
      console.log(this.uploadText);
      const a = document.createElement("a");
      a.href = this.uploadText.fail_url;
      a.target = "_blank";
      a.click();
    },
    downloadSuccess() {
      batch_add({
        project_id: this.proId,
        all_success_user_infos: this.uploadText.all_success_user_infos,
      }).then((res) => {
        this.$notify({
          title: "成功",
          message: res.msg,
          type: "success",
        });
        this.getUserList();
        this.groupDialogVisible = false;
      });
    },
    downloadTem() {
      let prod_url =
        sessionStorage.getItem("environment") === "PROD" ? "api2/" : "";
      // 浏览器打开新的标签页
      const a = document.createElement("a");
      a.href =
        process.env.VUE_APP_BASE_API +
        prod_url +
        "/v1.0/iwrs/project_user/download/user/template?user_id=" +
        this.userDetail.id +
        "&project_id=" +
        this.proId;
      a.target = "_blank";
      a.click();
    },
    downloadSubmit() {
      let formData = new FormData();
      formData.append("file", this.files.raw);
      formData.append("project_id", this.proId);
      batch_add_check(formData).then((res) => {
        this.uploadBol = false;
        this.groupdialogTitle = "用户信息上传进度";
        this.uploadText = res.data;
      });
    },
    fail() {
      this.userDialogVisible = false;
      this.ruleForm = {
        name: "",
        email: "",
        phone: "",
        role_id: "",
        unit_id_list: "",
        //后端接口需要此格式
        authority: {
          项目管理: [],
          项目首页: [],
          单位管理: [],
          角色管理: [],
          访视管理: [],
          用户管理: [],
          通知管理: [],
          随机管理: [],
          盲底管理: [],
          受试者管理: [],
          受试者脱落: [],
          紧急揭盲: [],
          揭盲管理: [],
          操作轨迹: [],
        },
      };
      this.getUserList();
    },
    filterChange(filter) {
      console.log(filter);
      this.enable = filter.is_enable;
      this.getUserList();
    },
    getRoleList() {
      roleList({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.authorityData = res.data;
            } else {
              this.authorityData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleData(res) {
      if (res) {
        const obj = {};
        res.map((item) => {
          const val = obj[item[0]];
          if (val) {
            val.push(item[1]);
            obj[item[0]] = val;
          } else {
            const array = [];
            array.push(item[1]);
            obj[item[0]] = array;
          }
        });
        console.log(obj);
        this.reqObj = obj;
      }
    },
    // 根据选择的角色查看权限
    changeRole(val) {
      const params = {
        project_id: this.proId,
        id: val,
      };
      detailRole(params).then((res) => {
        console.log(res);
        if (res && res.code === 0) {
          //清空并遍历权限列表赋值给form
          this.ruleForm.authority = {
            项目管理: [],
            项目首页: [],
            单位管理: [],
            角色管理: [],
            访视管理: [],
            用户管理: [],
            通知管理: [],
            随机管理: [],
            盲底管理: [],
            受试者管理: [],
            受试者脱落: [],
            紧急揭盲: [],
            揭盲管理: [],
            操作轨迹: [],
          };
          for (const key in res.data.authority) {
            this.$set(this.ruleForm.authority, key, res.data.authority[key]);
            this.$forceUpdate();
          }
        } else {
          this.$message(res.msg);
        }
      });
    },
    handleExportUser() {
      console.log(process.env.VUE_APP_BASE_API);
      console.log(process.env.VUE_APP_BASE_API2);

      if (this.to) {
        if (this.to === "本地") {
          let baseUrl = "";
          if (this.res_environment === "UAT") {
            baseUrl =
              process.env.VUE_APP_BASE_API +
              "/v1.0/iwrs/project_user/export?project_id=" +
              this.proId +
              "&user_id=" +
              this.userDetail.id +
              "&to=" +
              "本地";
          } else {
            baseUrl =
              process.env.VUE_APP_BASE_API2 +
              "/v1.0/iwrs/project_user/export?project_id=" +
              this.proId +
              "&user_id=" +
              this.userDetail.id +
              "&to=" +
              "本地";
          }
          window.open(baseUrl, "_self");
          this.downDialogVisible = false;
        } else {
          const params = {
            project_id: this.proId,
            to: this.to,
            user_id: this.userDetail.id,
          };
          exportUser(params)
            .then((res) => {
              console.log(res);
              if (this.to === "本地及邮箱") {
                this.export_excel_file(res);
              }
              this.handleCancelExport();
              this.$message({
                message: "发送成功",
                type: "success",
              });
            })
            .catch((res) => {
              this.$message.error("发送失败");
            });
        }
      } else {
        this.$message.error("请选择导出位置");
      }
    },
    export_excel_file(export_data) {
      // console.log(this.$store.getters.file_type)
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([export_data], {
        type: this.$store.getters.file_type,
      });
      let link = document.createElement("a");
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = this.$store.getters.file_name;
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
    },
    handleCancelExport() {
      this.to = "";
      this.downDialogVisible = false;
    },
    getAllUser() {
      allUser({ project_id: this.proId })
        .then((res) => {
          if (res.success) {
            this.allUser = res.data.map((item) => {
              const obj = {};
              obj.name = item.name;
              obj.id = item.id;
              return obj;
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getImportList() {
      const params = {
        project_id: this.proId,
      };
      userImport(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.leftData = res.data.map((item) => {
              const obj = {};
              obj.name = item.name;
              obj.email = item.email;
              obj.phone = item.phone;
              obj.id = item.id;
              obj.key = item.key;
              obj.phone = item.phone;
              obj.userId = item.user_id;
              return obj;
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;text-align:center;";
      }
    },
    getUserList() {
      this.loading = true;
      const params = {
        project_id: this.proId,
        key: this.key_unit,
        page: this.currentPage - 1,
        page_size: this.pageSize,
        is_enable: this.enable,
      };
      const res = this.$qs.stringify(params, { arrayFormat: "repeat" });
      getUserListApi(res)
        .then((res) => {
          if (res && res.code === 0) {
            this.loading = false;
            if (res.data && res.data.length > 0) {
              this.infoData = res.data;
              this.total = res.total;
            } else {
              this.infoData = [];
            }
            // this.getImportList();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 关联单位
    getUnitNo() {
      getUnitNo({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.unitList = res.data;
            } else {
              this.unitList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    getRoleNo() {
      getRoleNo({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.roleList = res.data;
            } else {
              this.roleList = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    allUnit(val) {
      if (val) {
        this.ruleForm.unit_id_list = this.unitList.map((item) => {
          return item.id;
        });
      } else {
        this.ruleForm.unit_id_list = [];
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getUserList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    },
    createUser() {
      this.userId = "";
      this.userDialogVisible = true;
    },
    userImpor() {
      this.uploadBol = true;
      this.groupdialogTitle = "用户批量上传";
      this.files = new FormData();
      this.groupDialogVisible = true;
    },
    cancel() {
      this.clearForm = false;
      this.userId = "";
      this.ruleForm.name = "";
      this.ruleForm.email = "";
      this.ruleForm.phone = "";
      this.ruleForm.role_id = "";
      this.ruleForm.unit_id_list = "";
      this.ruleForm.authority = [];
      this.userDialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.getUserList();
    },
    submitForm() {
      const { name, email, phone, unit_id_list, role_id } = this.ruleForm;
      // console.log(this.ruleForm);
      if (name && email && phone && unit_id_list.length && role_id) {
        const params = {
          ...this.ruleForm,
          project_id: this.proId,
          is_all_unit: this.isAllUnit,
        };
        !this.userId
          ? this.addUser(params)
          : this.editUesr({ ...params, id: this.userId });
      } else {
        this.$message.error("用户数据填写不完整");
      }
      //
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     const params = {
      //       name: this.ruleForm.name,
      //       email: this.ruleForm.email,
      //       phone: this.ruleForm.phone,
      //       role_id: this.ruleForm.role_id,
      //       unit_id_list: this.ruleForm.unit_id_list,
      //       project_id: this.proId,
      //       authority: this.reqObj,
      //     };
      //     if (!this.userId) {
      //       this.addUser(params);
      //     } else {
      //       params.id = this.userId;
      //       this.editUesr(params);
      //     }
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    addUser(params) {
      this.is_loading = true;
      addUser(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.userDialogVisible = false;
            this.fail();
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    editUesr(params) {
      this.is_loading = true;
      editUser(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.userId = "";
            this.$message({
              message: "用户信息修改成功，项目权限需重新进入该项目生效！",
              type: "success",
            });
            this.fail();
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    disableClick(row) {
      const param = {
        id: row.id,
        project_id: this.proId,
        enable: false,
      };
      enable(param)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getUserList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    enableClick(row) {
      const param = {
        id: row.id,
        project_id: this.proId,
        enable: true,
      };
      enable(param)
        .then((res) => {
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getUserList();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    del(row) {
      this.$confirm(
        `是否确认删除用户 <span style="color: #698CFC;font-size: 14px;font-weight: bold;">${row.name} </span>?`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "btn-custom-cancel",
          type: "warning",
        }
      )
        .then(() => {
          const params = {
            id: row.id,
            project_id: this.proId,
          };
          del(params)
            .then((res) => {
              if (res && res.code === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getUserList();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((res) => {
              console.log(res.msg);
            });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },

    detail(row) {
      console.log(row);
      this.userDialogVisible = true;
      this.userId = row.id;
      this.ruleForm = row;
      this.$set(this.ruleForm, "authority", {});
      for (const key in row.all_authority) {
        this.$set(this.ruleForm.authority, key, row.all_authority[key]);
      }
    },
    down() {
      this.downDialogVisible = true;
    },
  },
  watch: {
    key_unit(value) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getUserList, 500);
    },
    ruleForm: {
      handler(newVal, oldVal) {
        if (
          newVal.unit_id_list.length === this.unitList.length &&
          this.unitList.length
        ) {
          this.isAllUnit = true;
        } else {
          this.isAllUnit = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  text-align: right;
}
.footBtns {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.ok {
  width: 120px;
  height: 32px;
  background: #709bcb;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.ok:hover {
  background: #fd8824;
}
//弹出取消按钮
.cancel {
  text-align: center;
  width: 120px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #709bcb;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #709bcb;
  line-height: 32px;
  margin-left: 30px;
}
.cancel:hover {
  background: #fd8824;
  border: 1px solid #ffffff;
  color: #ffffff;
}

.container-table {
  margin-top: 20px;
}
::v-deep {
  .export .el-dialog__header {
    padding: 0;
  }
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}

.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}

.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}

.colm-left {
  line-height: 26px;
}

.pages {
  margin-top: 30px;
  text-align: right;
}

.edit {
  font-size: 12px;
  margin-right: 10px;
}

.el-dialog__header {
  padding: 0px;
}

.container-table {
  border: 1px solid #e5eeff;
}

.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}

.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}

.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}

.export {
  width: 90%;
  margin: auto;
}
.roleadd {
  .footBtns {
    margin-top: 2rem;
    display: flex;
    justify-content: center;

    .el-button--primary {
      width: 120px;
      height: 32px;
      background: #709bcb;
      border-radius: 4px;
      cursor: pointer;
      font-size: 16px;
      color: #ffffff;
      line-height: 0.3;
      text-align: center;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .el-button--default {
      text-align: center;
      width: 120px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid #709bcb;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #709bcb;
      line-height: 0.2;
      margin-left: 30px;
    }
  }
  .el-form {
    width: 100%;

    .form_box {
      // padding: 0 5%;
      background-color: #fff;
      position: relative;

      .svg_delect {
        position: absolute;
        right: 20px;
        top: 0;
        cursor: pointer;
        height: 25px;
        width: 25px;
      }

      .el-row {
        // padding: 10px;
        // margin: 0 8%;
        .el-row {
          border-bottom: 1px solid #e8e8e8;
        }

        .el-row_title {
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          text-align: left;
          font-weight: 500;
          padding: 0px 10px;
          box-sizing: content-box;

          i {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #bfbfbf;
            border-radius: 50%;
            margin-right: 5px;
            vertical-align: middle;
          }
        }

        .el-col {
          height: 40px;
          line-height: 40px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #595959;
          white-space: nowrap;
        }

        .el-row_first {
          text-align: left !important;
          padding-left: 20px;
        }

        .noBorder {
          border-bottom: 1px solid #fff;
        }
      }

      .title_row {
        display: flex;
        margin-bottom: 15px;
        line-height: 35px;

        span {
          display: inline-block;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #595959;
          font-size: 14px;
          text-align: right;
          width: 120px;

          .svg-icon {
            height: 0.5rem !important;
            width: 0.5rem !important;
            vertical-align: 0.3em;
          }
        }

        .el-input,
        .el-select {
          width: 280px;
        }
      }
    }
  }
  .back {
    margin-bottom: 20px;
  }

  ::v-deep {
    .el-checkbox__label {
      font-size: 12px;
      padding-left: 5px;
    }

    .el-input--suffix .el-input__inner {
      padding-right: 18px;
      // height: 24px;
      // line-height: 24px;
    }

    .el-input__icon {
      width: 15px;
    }
  }
}
</style>
